import Locality from '../locality/Locality';
import prependProtocol from '../common/utils/prependProtocol';
import xhrPromise from '../common/utils/xhrPromise';
import { ContentCallResponse } from '../common/interfaces';

export interface GetContentDataArgs {
  body: Locality;
  contentHost: string;
  contentId: string;
  headers: Record<string, string>;
  tenantId: string;
}

/**
 * Get data necessary to initialize the sdk.
 * @param args - see: GetContentDataArgs
 *
 * @returns Promise promise that contains a \{data, request\} payload on success
 */

export default function (
  args: GetContentDataArgs
): Promise<ContentCallResponse> {
  const host = prependProtocol(args.contentHost);
  const { body, contentId, headers, tenantId } = args;
  const url = `${host}/api/tenant/${tenantId}/content/${contentId}`;
  return xhrPromise({ async: true, body, headers, method: 'POST', url });
}
